import $ from 'jquery';
import rimg from '@pixelunion/rimg-shopify';
import EventHandler from '@pixelunion/events';

import ProductGridItem from '../components/ProductGridItem';
import SearchForm from '../components/search/SearchForm';
import SearchFilterDisclosures from '../components/search/SearchFilterDisclosures';

export default class StaticSearch {
  constructor(section) {
    this.section = section;
    this.el = section.el;
    this.responseContainer = this.section.el.querySelector('[data-html]');
    this.$el = $(section.el);
    this.searchFieldSelector = '[data-live-search]';
    this.summaryElSelector = '[data-filter-group-summary]';
    this.filterFormSelector = '[data-search-filter-form]';
    this.filterInputSelector = '[data-filter-checkbox]';
    this.filterRemoveSelector = '[data-filter-remove]';
    this.rangeInputSelector = '[data-filter-range]';
    this.paginationSelector = 'a.pagination__item';

    this.$searchField = this.$el.find(this.searchFieldSelector);
    this.paginationLinks = this.section.el.querySelectorAll(this.paginationSelector);
    this.filterInputs = this.el.querySelectorAll(this.filterInputSelector);
    this.filterRemoveLinks = this.el.querySelectorAll(this.filterRemoveSelector);
    this.rangeInputs = this.el.querySelectorAll(this.rangeInputSelector);

    this.ajaxEvents = new EventHandler();
    this.timeout = null;
    this.processing = false;

    this._ajaxFetch = this._ajaxFetch.bind(this);
    this._handlePaginationClick = this._handlePaginationClick.bind(this);
    this._handleFilterClick = this._handleFilterClick.bind(this);
    this._handleRangeInput = this._handleRangeInput.bind(this);
    this._initProducts = this._initProducts.bind(this);

    // Product items
    this.productItems = [];
    this._initProducts();
    this._bindEvents();

    this.searchForm = new SearchForm(this.$searchField);
    this.disclosures = new SearchFilterDisclosures(this.el);
    window.onpopstate = event => {
      event.preventDefault();
      event.stopPropagation();
      this._ajaxFetch(event.state.path, event.state.toPage, event.type);
    };
  }

  _bindEvents() {
    this.paginationLinks = this.section.el.querySelectorAll(this.paginationSelector);
    this.filterInputs = this.el.querySelectorAll(this.filterInputSelector);
    this.rangeInputs = this.el.querySelectorAll(this.rangeInputSelector);
    this.filterRemoveLinks = this.el.querySelectorAll(this.filterRemoveSelector);

    this.paginationLinks.forEach(el => {
      this.ajaxEvents.register(el, 'click', this._handlePaginationClick);
    });

    this.filterInputs.forEach(el => {
      this.ajaxEvents.register(el, 'change', this._handleFilterClick);
    });

    this.rangeInputs.forEach(el => {
      this.ajaxEvents.register(el, 'change', this._handleRangeInput);
      this.ajaxEvents.register(el, 'keyup', this._handleRangeInput);
    });

    this.filterRemoveLinks.forEach(el => {
      this.ajaxEvents.register(el, 'click', this._ajaxFetch);
    });
  }

  _ajaxFetch(fetchUrl = '', pageNumber = 1, eventType = null) {
    this.processing = true;
    this.responseContainer.classList.add('processing');
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    this.disclosures.closeAllDropdowns();
    this.disclosures.unload();
    this.ajaxEvents.unregisterAll();

    fetch(fetchUrl)
      .then(response => response.text())
      .then(textResponse => {
        const html = new DOMParser().parseFromString(textResponse, 'text/html').querySelector('[data-html]');

        this.responseContainer.innerHTML = html.innerHTML;

        this.searchForm.unload();
        this.$searchField = this.$el.find(this.searchFieldSelector);
        this.searchForm = new SearchForm(this.$searchField);

        rimg.watch(this.responseContainer);
        this._initProducts();
        this.disclosures.init();

        this._bindEvents();

        if (eventType !== 'popstate') {
          const newUrl = `${window.location.protocol}//${window.location.host}${fetchUrl}`;
          try {
            window.history.pushState({ path: fetchUrl, toPage: pageNumber }, '', newUrl);
          } catch {
            // do nothing (we're probably in the editor)
          }
        }

        this.responseContainer.classList.remove('processing');
        this.processing = false;
      });
  }

  _getFilterQuery(targetEl) {
    let searchString = '';
    if (targetEl.hasAttribute('data-filter-remove')) {
      searchString = targetEl.href.indexOf('?') === -1
        ? ''
        : targetEl.href.slice(targetEl.href.indexOf('?') + 1);
    } else {
      const filterForm = this.el.querySelector(this.filterFormSelector);

      if (filterForm) {
        const formData = new FormData(filterForm);
        searchString = new URLSearchParams(formData).toString();
      }
    }

    return searchString;
  }

  _handleFilterClick(event) {
    if (this.processing) return;

    event.preventDefault();
    event.stopPropagation();

    const target = event.currentTarget;
    const filterItem = event.currentTarget.closest('[data-filter-item]');
    const filterQuery = this._getFilterQuery(event.target);
    const targetUrl = target.getAttribute('data-href');
    const fetchUrl = targetUrl.indexOf('?') === -1
      ? `${targetUrl}?${filterQuery}`
      : `${targetUrl}&${filterQuery}`;
    const pageNumber = 1;

    filterItem.classList.toggle('filter-item--active');
    filterItem.classList.toggle('filter-item--inactive');

    if (this.timeout !== null) {
      clearTimeout(this.timeout);
    }

    // Wait for user to finish entering input before reloading page
    this.timeout = setTimeout(() => {
      this._ajaxFetch(fetchUrl, pageNumber, event.type);
    }, 1000);
  }

  _handleRangeInput(event) {
    if (this.processing) return;

    event.preventDefault();
    event.stopPropagation();

    if (event.key === 'Tab') return;

    const target = event.currentTarget;
    const filterQuery = this._getFilterQuery(target);
    const targetUrl = target.getAttribute('data-href');

    const fetchUrl = targetUrl.indexOf('?') === -1
      ? `${targetUrl}?${filterQuery}`
      : `${targetUrl}&${filterQuery}`;
    const pageNumber = 1;

    if (this.timeout !== null) {
      clearTimeout(this.timeout);
    }

    // Wait for user to finish entering input before reloading page
    this.timeout = setTimeout(() => {
      this._ajaxFetch(fetchUrl, pageNumber, event.type);
    }, 2000);
  }

  _handlePaginationClick(event) {
    const fetchUrl = event.currentTarget
      .getAttribute('href')
      .replace('&view=undefined', '');
    const pageNumber = event.currentTarget.getAttribute('data-to-page');

    this._ajaxFetch(fetchUrl, pageNumber, event.type);
  }

  _initProducts() {
    if (this.productItems.length > 0) {
      this.productItems.forEach(productItem => {
        productItem.unload();
      });

      this.productItems = [];
    }

    const $productItems = this.$el.find('[data-product-item]');

    $productItems.each((i, productItem) => {
      this.productItems.push(
        new ProductGridItem({
          $el: $(productItem),
          id: this.section.id,
          product: JSON.parse(productItem.querySelector('[data-product-data]').innerHTML),
          lazy: true,
        }),
      );
    });
  }

  onSectionUnload() {
    this.searchForm.unload();

    this.productItems.forEach(productItem => {
      productItem.unload();
    });
  }
}
